import ApiToken from "./ApiToken";

export default ApiToken;
